import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import { getCache, setCache } from '../utils/cache';
import RenderMonitor from '../components/RenderMonitor';

function ArchivedCourses() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activatingId, setActivatingId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError('');
      const CACHE_KEY = 'archived.courses.v1';
      const ttlMs = 2 * 60 * 1000;
      const cached = getCache(CACHE_KEY, ttlMs);
      if (cached) {
        setCourses(cached);
        setLoading(false);
        return;
      }
      const { data, error: fetchErr } = await supabase
        .from('courses')
        .select('id, name')
        .eq('active', false);
      if (fetchErr) {
        setError('Could not fetch archived courses');
        setLoading(false);
        return;
      }
      setCache(CACHE_KEY, data || []);
      setCourses(data || []);
      setLoading(false);
    };
    fetchData();
  }, []);

  const makeActive = async (id) => {
    setActivatingId(id);
    const { error: updateErr } = await supabase
      .from('courses')
      .update({ active: true })
      .eq('id', id);
    setActivatingId(null);
    if (!updateErr) {
      const updated = courses.filter((c) => c.id !== id);
      setCourses(updated);
      setCache('archived.courses.v1', updated);
    }
  };

  return (
    <div className="dashboard-page">
      <RenderMonitor componentName="ArchivedCourses" />

      <button
        type="button"
        onClick={() => navigate('/admin/courses')}
        className="modern-button modern-button-secondary modern-mb-6"
      >
        ← All Courses
      </button>

      <div className="modern-flex modern-justify-between modern-items-center modern-mb-6">
        <h1 className="modern-title" style={{ marginBottom: 0 }}>Archived Courses</h1>
      </div>

      <div className="modern-list-panel">
        {loading ? (
          <div className="modern-list-empty">Loading archived courses…</div>
        ) : error ? (
          <div className="modern-list-empty" style={{ color: '#dc2626', fontStyle: 'normal' }}>{error}</div>
        ) : courses.length === 0 ? (
          <div className="modern-list-empty">No archived courses.</div>
        ) : (
          courses.map((course) => (
            <div key={course.id} className="modern-list-row">
              <span className="modern-list-row-label">{course.name || 'Untitled Course'}</span>
              <button
                type="button"
                className="modern-button modern-button-success"
                style={{ fontSize: 13, padding: '6px 12px' }}
                onClick={() => makeActive(course.id)}
                disabled={activatingId === course.id}
              >
                {activatingId === course.id ? 'Restoring…' : 'Restore'}
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ArchivedCourses;
